export type LegacyTrainingDestination = {
  pathname: string;
  search: string;
};

const remainingSearch = (params: URLSearchParams): string => {
  const value = params.toString();
  return value ? `?${value}` : '';
};

export const resolveLegacyTrainerViewerDestination = (search: string): LegacyTrainingDestination => {
  const params = new URLSearchParams(search);
  const exerciseId = params.get('exerciseId')?.trim();
  params.delete('exerciseId');

  return {
    pathname: exerciseId
      ? `/training-practices/${encodeURIComponent(exerciseId)}`
      : '/training-practices',
    search: remainingSearch(params),
  };
};

export const resolveLegacyTrainerPlanDestination = (
  planId: string | undefined,
  search: string,
): LegacyTrainingDestination => ({
  pathname: planId ? `/plans/${encodeURIComponent(planId)}/edit` : '/training-exercise-plans',
  search,
});
